'use client';
import React, { useState, useRef } from 'react';
import ShiningNumber from '../ShiningNumber/ShiningNumber';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

import { debug } from '@/lib/debug';
gsap.registerPlugin(useGSAP, ScrollTrigger);

interface ScrollActivatedNumberProps {
    number: string;
    size: number;
    onRef?: (el: HTMLDivElement | null) => void;
    // ScrollTrigger start line at which the number lights up
    start?: string;
}

const ScrollActivatedNumber: React.FC<ScrollActivatedNumberProps> = ({ number, size, onRef, start = "top bottom-=35%" }) => {
    const [isActive, setIsActive] = useState(false);
    const numberRef = useRef<HTMLDivElement>(null);


    useGSAP(() => {
        const numberElement = numberRef.current;
        if (numberElement) {
            ScrollTrigger.create({
                trigger: numberElement,
                start,
                // end: "top bottom-=25%",
                onEnter: () => {
                    // debug.log("onEnter fired for", number);
                    setIsActive(true);
                },
                onLeaveBack: () => {
                    // debug.log("onLeaveBack fired for", number);
                    setIsActive(false);
                },
                // onRefresh: (self) => {
                    // Check state after refresh - this fires on initial creation and on ScrollTrigger.refresh()
                    // debug.log("onRefresh - isActive: for :", number);
                    // setIsActive(selfisActive);
                // },
                // markers: true,
                // id: `scroll-activated-number-${number}`
            });

            // Refresh ScrollTrigger to calculate initial state
            // ScrollTrigger.refresh();
        }
    }, { dependencies: [start], revertOnUpdate: true });

    return (
        <div 
            ref={(el) => {
                numberRef.current = el;
                onRef?.(el);
            }}
        >
            <ShiningNumber
                number={number}
                active={isActive}
                size={size}
            />
        </div>
    );
};

export default ScrollActivatedNumber;

